export const ADTRACE_APP_TOKEN = process.env.NEXT_PUBLIC_ADTRACE_APP_TOKEN ?? ''
export const ADTRACE_ENVIRONMENT =
    process.env.NEXT_PUBLIC_ADTRACE_ENVIRONMENT === 'production' ? 'production' : 'sandbox'
